// Copyright 2005-2011 David Caldwell <david@porkrind.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_numeric_order=piles.in_numeric_order, king=piles.king, ace=piles.ace,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;

solitaire.golf = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.stock = new this.stock_pile("stock", this);
        this.foundation = new this.foundation_pile("foundation", this);
        this.tableau = [];
        for (var i=0; i<7; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        var me = this;
        this.ui.deck_play = this.stock.onclick = function() {
            if (!me.stock.pile.length) return;
            me.push_state();
            me.moves.push("*"+me.stock.move_char());
            me.stock.top().face = up;
            me.animate_move(me.do_move([{ from:me.stock, to:me.foundation, fstart:me.stock.top_index(), n:1, internal:true }]));
            me.end_of_move();
        };

        this.fix_replay_move = function(moves) {
            return moves.replace(/^01/, "*0"); // Moves from deck to foundation -> click on deck.
        };
    }
    static variants = { golfwrap: { variation: "wrap" },
                        golfks:   { variation: "king_stop" } };

    valid_options = { variation: option_def("enum",
                                            "normal", "Queens can be played on Kings",
                                            "king_stop", "A King on the foundation stops further building",
                                            "wrap", "Aces can be played on Kings and vice versa"),
                      decks: option_def("number", 1, "Number of decks to use") };

    foundation_pile = class extends pile {
        splice = pile.prototype.splice_and_turn_under;
        accept_stacks = false;
        accept(card) { return (this.game.options.variation!="king_stop" || this.top().rank != king) &&
                              (in_numeric_order(this.top(), card) ||
                               in_numeric_order(card, this.top())) ||
                              (this.game.options.variation=="wrap" && (this.top().rank == king && card.rank       == ace ||
                                                                       card.rank       == king && this.top().rank == ace)); }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    }

    tableau_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
    };

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = 1/90;
        yoffset = 1/131;
        maxstack = 52-35-1;
    };


    deal(deck) {
            this.stock.pile = deck;
            for (var c=0; c<5 * this.tableau.length; c++) {
                this.tableau[c%this.tableau.length].push(this.stock.pop());
                this.tableau[c%this.tableau.length].top().face = up;
            }
            this.foundation.push(this.stock.pop());
            this.foundation.top().face = up;
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length && this.foundation.accept(this.tableau[i].top()))
                    return NOT_COMPLETE;
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return this.stock.pile.length == 0 && GAME_OVER;
            return WON;
    }

    score() {
            return 35 - this.count_cards_in(this.tableau);
    }

    layout = grid(["tableau0", "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6" ],
                  [{ y: +1 },
                   "stock", void 0, "foundation"]);
}

module.exports = solitaire.golf;
// Copyright 2005-2011 David Caldwell <david@porkrind.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_numeric_order=piles.in_numeric_order, king=piles.king, ace=piles.ace,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;

solitaire.golf = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.stock = new this.stock_pile("stock", this);
        this.foundation = new this.foundation_pile("foundation", this);
        this.tableau = [];
        for (var i=0; i<7; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        var me = this;
        this.ui.deck_play = this.stock.onclick = function() {
            if (!me.stock.pile.length) return;
            me.push_state();
            me.moves.push("*"+me.stock.move_char());
            me.stock.top().face = up;
            me.animate_move(me.do_move([{ from:me.stock, to:me.foundation, fstart:me.stock.top_index(), n:1, internal:true }]));
            me.end_of_move();
        };

        this.fix_replay_move = function(moves) {
            return moves.replace(/^01/, "*0"); // Moves from deck to foundation -> click on deck.
        };
    }
    static variants = { golfwrap: { variation: "wrap" },
                        golfks:   { variation: "king_stop" } };

    valid_options = { variation: option_def("enum",
                                            "normal", "Queens can be played on Kings",
                                            "king_stop", "A King on the foundation stops further building",
                                            "wrap", "Aces can be played on Kings and vice versa"),
                      decks: option_def("number", 1, "Number of decks to use") };

    foundation_pile = class extends pile {
        splice = pile.prototype.splice_and_turn_under;
        accept_stacks = false;
        accept(card) { return (this.game.options.variation!="king_stop" || this.top().rank != king) &&
                              (in_numeric_order(this.top(), card) ||
                               in_numeric_order(card, this.top())) ||
                              (this.game.options.variation=="wrap" && (this.top().rank == king && card.rank       == ace ||
                                                                       card.rank       == king && this.top().rank == ace)); }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    }

    tableau_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
    };

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = 1/90;
        yoffset = 1/131;
        maxstack = 52-35-1;
    };


    deal(deck) {
            this.stock.pile = deck;
            for (var c=0; c<5 * this.tableau.length; c++) {
                this.tableau[c%this.tableau.length].push(this.stock.pop());
                this.tableau[c%this.tableau.length].top().face = up;
            }
            this.foundation.push(this.stock.pop());
            this.foundation.top().face = up;
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length && this.foundation.accept(this.tableau[i].top()))
                    return NOT_COMPLETE;
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return this.stock.pile.length == 0 && GAME_OVER;
            return WON;
    }

    score() {
            return 35 - this.count_cards_in(this.tableau);
    }

    layout = grid(["tableau0", "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6" ],
                  [{ y: +1 },
                   "stock", void 0, "foundation"]);
}

module.exports = solitaire.golf;
